import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ListPrivacyRequestsResponse, PrivacyRequest } from 'shared';
import { api } from '@/lib/api';

// Requests Diggers and Encarregados make from the PWA about their own data.
// Staff answer them (export or delete the person) and mark them handled.

export type PrivacyRequestFilter = 'abertos' | 'tratados';

/** GET /api/privacy-requests?estado= — open ones oldest first, or the latest handled. */
export function usePrivacyRequests(estado: PrivacyRequestFilter) {
  return useQuery({
    queryKey: ['privacy-requests', estado],
    queryFn: () => api.get<ListPrivacyRequestsResponse>(`/api/privacy-requests?estado=${estado}`),
    staleTime: 30_000,
  });
}

/** POST /api/privacy-requests/{id}/close */
export function useClosePrivacyRequest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.post<PrivacyRequest>(`/api/privacy-requests/${id}/close`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['privacy-requests'] }),
  });
}
